import React from "react";
import { IneligibleScreen } from "../../EligibilityCheckerGeneric/ResultScreens";

interface NoPlacesAvailableScreenProps {
  title: string;
  heading: string;
  body: string;
}

const NoPlacesAvailableScreen: React.FC<NoPlacesAvailableScreenProps> = props => {
  const { title, heading, body } = props;
  return <IneligibleScreen title={title} heading={heading} bodyText={body} hasContactUs={false} />;
};

export default NoPlacesAvailableScreen;
